define(["jquery"],
    function ($) {

        function registerLinkClick(link, itemId) {
            registerClick($(link).attr("href"), $(link).text(), itemId);
            registerItemClick($(link).attr("href"), $(link));
        }

        function registerButtonClick(button, itemId) {
            // TODO Get Button Action for Data
            registerClick("Button", $(button).text(), itemId);
            registerItemClick("Button", $(button));
        }

        function registerItemClick(data, item) {
            $itemId = $(item).attr('itemId');
            if ($itemId) {
                registerClick(data, $(item).text(), $itemId);
            }
        }

        function registerVideoClick(video, itemId) {
            registerClick("Video", $("source", $(video)).attr("src"), itemId);
        }

        function registerMenuClick(menuLink, itemId) {
            registerClick(menuLink.href, $(menuLink).text(), itemId, true);
        }

        function registerClick(data, text, itemId, menuClick = false) {
            // Data: Href For a link, Form-Action? for a button i.e.:  "href"
            // Text: InnerText for a link, Text for a button  i.e.: "link text"
            // Item Id: Guid for the component containing the click event scope i.e.: "{2017EB8E-3A17-4709-B2DB-4B2CA57FC99B}"

            $.post("/Analytics/RegisterClickPageEvent", { data: data, text: text, itemId: itemId, menuClick: menuClick });
        }

        return new function analytics() {

            this.Initialize = function (scope, itemId) {
                // Register all html Anchor (a) in the defined scope
                $("a", scope).mousedown(function (e) { registerLinkClick(e.currentTarget, itemId); });

                // Register all buttons (input type=button, button) in the defined scope
                $(":button", scope).mousedown(function (e) { registerButtonClick(e.currentTarget, itemId); });
            };
            this.InitializeMenuTracking = function (scope, itemId) {

                $("a", scope).mousedown(function (e) { registerMenuClick(e.currentTarget, itemId); });
            };

            this.InitializeHtmlVideo = function (scope, itemId) {
                $("video", scope).on("play", function (e) { registerVideoClick(e.currentTarget, itemId); });
            };

            this.registerClick = function (data, text, itemId, menuClick = false) {
                registerClick(data, text, itemId, menuClick);
            };
        };
    });